// Skip-to-content link for keyboard / screen-reader users.
// Visually hidden until focused; first focusable element on the page.
// Jumps focus to <main id="main-content" tabindex="-1">.
export const SkipNav = () => (
  <a
    href="#main-content"
    className="sr-only sr-only-focusable"
    data-testid="skip-to-content"
  >
    Skip to main content
  </a>
);
